import React, { useCallback, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { I18n } from 'aws-amplify';
import styles from './styles.module.css';

const href = `${process.env.PUBLIC_URL}/management/account`;

const SwitchAccountMenu = ({ location, accounts, switchAccount, open, onClose }) => {
  const isMypage = useMemo(() => !location.pathname.includes('management'), [location.pathname]);
  const className = useMemo(() => `${styles.menu} ${open ? styles.visible : styles.hidden}`, [
    open,
  ]);

  const handleClick = useCallback(
    (e, index) => {
      e.preventDefault();
      onClose();
      switchAccount(index);
      if (isMypage) window.open(href);
    },
    [isMypage, onClose, switchAccount]
  );

  return (
    <div className={className}>
      <header>
        <span className={styles.title}>
          {isMypage ? I18n.get('Select Account') : I18n.get('Switch Account')}
        </span>
        <div className={styles.closeIcon} onClick={onClose}></div>
      </header>
      <h3 className={styles.subtitle}>
        {isMypage
          ? I18n.get(
              'Please select the account for which you wish to view the administration screen.'
            )
          : I18n.get('Please select an account.')}
      </h3>
      <ul>
        {accounts.map((account, index) => (
          <li key={index}>
            {isMypage ? (
              <a
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                onClick={(e) => handleClick(e, index)}
              >
                {account.displayName}
              </a>
            ) : (
              <span
                onClick={() => {
                  onClose();
                  switchAccount(index);
                }}
              >
                {account.displayName}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default withRouter(SwitchAccountMenu);
